export default __webpack_public_path__ + "static/media/2504153.256e4988.jpg";